var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoImgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7842 28.4823L9.46754 30.6011C9.21422 30.7254 7.21182 31.4671 7 31.6337C11.0056 34.3866 14.5409 35 18.0905 35C21.614 35 25.4904 33.2491 28 31.3656C27.7685 31.1898 26.8686 30.7539 26.5901 30.6291L21.9677 28.5496C21.3705 28.2809 20.9932 27.7316 20.9932 27.1308V25.4989C21.1232 25.3657 21.2717 25.1948 21.4305 24.9929C22.0605 24.1921 22.5371 23.3113 22.8674 22.3872C23.4603 22.2226 23.8971 21.7299 23.8971 21.1443V19.4023C23.8971 19.0191 23.7076 18.6767 23.4134 18.437V15.9188C23.4134 15.9188 23.9882 12 18.0905 12C12.1928 12 12.7677 15.9188 12.7677 15.9188V18.437C12.4729 18.6767 12.284 19.0191 12.284 19.4023V21.1443C12.284 21.6032 12.552 22.007 12.9533 22.2403C13.437 24.1351 14.7036 25.4989 14.7036 25.4989V27.0905C14.703 27.6702 14.3503 28.2042 13.7842 28.4823Z",
    fill: "#A2A2A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImgUser);
export default __webpack_public_path__ + "static/media/no_img_user.ce0616c72449d2823f20cc9a85a4b6b1.svg";
export { ForwardRef as ReactComponent };